<template>
  <div>
    <fixed-list
      :dataSource="dataSource"
      :config="config"
      @onDataSourceChange="onDataSourceChange"
      @onPageChange="onPageChange"
      :queryParam="queryParam"
    >
      <p slot="elList">
        <el-table
          ref="pcListTable"
          :data="dataSource.Result"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
        >
          <el-table-column
            type="selection"
            width="55"
            v-if="!config.isDetailDisplay"
          ></el-table-column>
          <el-table-column
            v-for="(col, index, count) in dataSource.ColDefs.BodyFieldParams"
            :key="index"
            :prop="col.FieldName"
            :label="col.DisplayName"
            :render-header="bindFilter(queryParam, col)"
            :fixed="index == 0 && (!config || !config.isDetailDisplay)"
            :min-width="
              !config || !config.isDetailDisplay ? parseInt(col.Width) : 0
            "
            v-if="
              col.Visible &&
              (!config ||
                !config.isDetailDisplay ||
                (config.isDetailDisplay && index < 2))
            "
          >
            <template slot-scope="scope">
              <span v-if="col.FieldName === 'Code'"
                ><span
                  type="text"
                  style="text-decoration: underline; color: #1874cd; cursor: pointer;"
                  @click="contractCodeClick(scope.row)"
                  >{{ scope.row[col.FieldName] }}</span
                ></span
              >
              <span v-else> {{ scope.row[col.FieldName] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </p>
    </fixed-list>
    <!-- 合同附件列表弹窗（只读：预览/下载） -->
    <DialogEx :options="attachmentOptions" :title="'附件列表 - ' + (currentContractCode || '')" style="height:100%;">
      <div style="padding:10px;">
        <el-table :data="attachmentList" border style="width: 100%" v-loading="attachmentLoading">
          <el-table-column width="55" type="index" label="序号"></el-table-column>
          <el-table-column prop="FileName" label="文件名称" min-width="160"></el-table-column>
          <el-table-column prop="FileTitle" label="文件标题" min-width="120"></el-table-column>
          <el-table-column prop="CreatedUserName" label="上传人" width="100"></el-table-column>
          <el-table-column prop="CreatedTime" label="上传时间" width="160"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="success" size="small" style="margin-left:6px;" @click="filePreview(scope.row)">预览</el-button>
              <el-button type="primary" size="small" style="margin-left:6px;" @click="fileDownload(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!attachmentLoading && attachmentList.length === 0" style="text-align:center;color:#909399;padding:20px 0;">
          该合同暂无附件
        </div>
      </div>
    </DialogEx>
    <!-- 附件预览：图片走 ImagePreviewDialog，PDF/Office 等走 FilePreviewDialog -->
    <ImagePreviewDialog ref="imgPreviewDlg" />
    <FilePreviewDialog ref="filePreviewDlg" />
  </div>
</template>

<script>
import sha from '../../../scripts/sha.js';
import Cookie from '../../../scripts/cookie.js';
import FilePreviewDialog from '@/components/common/FilePreviewDialog.vue';
import ImagePreviewDialog from '@/components/common/ImagePreviewDialog.vue';

export default {
  data() {
    return {
      multipleSelection: [],
      // 由 getContractList 显式传入，优先于 customerId prop，
      // 避免父组件 watch 里调用时 prop 尚未更新而查到上一个客户的合同
      currentCustomerId: null,
      queryParam: {
        PageIndex: 1,
        PageSize: 10,
        PageParams: {},
        params: {},
      },
      dataSource: {
        ColDefs: {},
        Result: [],
        TotalCount: 0,
      },
      dialogConfig: {
        isDetailDisplay: false,
        isSelectionDisplay: true,
      },
      config: {
        isDetailDisplay: false,
        isSelectionDisplay: true,
      },
      // 合同附件列表弹窗（点击合同编码弹出，只读）
      attachmentOptions: { visible: false, showFooter: false, size: 'large' },
      attachmentList: [],
      attachmentLoading: false,
      currentContractCode: '',
      // 附件预览统一走 FilePreviewDialog 公共组件
    }
  },
  props: {
    customerId: {
      type: [String, Number],
      default: null,
    },
  },
  watch: {
    customerId: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.currentCustomerId = newVal
        this.initialize()
      }
    },
  },
  mounted() {
    this.initialize()
  },
  methods: {
    reloadPageList: function () {
      this.initialize()
    },
    initialize() {
      this.onPageChange(this.queryParam)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onPageChange(param) {
      var _this = this
      // fixedlist 直接修改 queryParam 并回传同一引用，这里克隆后再改 PageParams
      var query = this.Utils.cloneObj(this.queryParam)
      var CustomerId =
        query.params.CustomerId ||
        (this.currentCustomerId != null && this.currentCustomerId !== ''
          ? this.currentCustomerId
          : this.customerId)
      query.PageParams = {
        CustomerId: CustomerId,
      }
      this.$ajax.query(
        'omsapi/contractinfo/getcustomercrpagelist',
        'post',
        query,
        (data) => {
          _this.dataSource = data
        }
      )
    },
    onDataSourceChange(ds) {
      var _this = this
      _this.dataSource = {
        ColDefs: {
          BodyFieldParams: [],
        },
        Result: [],
        TotalCount: 0,
      }
      _this.$nextTick(function () {
        _this.dataSource = ds
      })
    },
    // 点击合同编码：查询该合同附件列表并弹窗（只读预览/下载）
    contractCodeClick(row) {
      var _this = this
      _this.currentContractCode = row.Code || ''
      _this.attachmentList = []
      _this.attachmentLoading = true
      _this.attachmentOptions.visible = true
      _this.$ajax.query(
        window.AppConfig.apiBaseUrl + 'omsapi/sysattachmentclient/getlistbyrelatedid',
        'get',
        { id: row.Id },
        (data) => {
          _this.attachmentLoading = false
          if (data && data.IsSuccess && data.Result) {
            _this.attachmentList = data.Result
          } else {
            _this.attachmentList = []
          }
        }
      )
    },
    // 构造附件下载接口完整地址（带 token）；inline=1 时后端以 inline 返回，浏览器可直接预览
    buildFileUrl(row, inline) {
      var domain = Cookie.get(Cookie.domain)
      var base = domain ? window.AppConfig.apiCustomerUrl : window.AppConfig.apiBaseUrl
      var url = base + 'omsapi/files/download?file=' + encodeURIComponent(row.FileName)
        + '&url=' + encodeURIComponent(row.AttachmentUrl)
        + '&token=' + sha.getToken()
      if (inline) {
        url += '&inline=1'
      }
      return url
    },
    fileDownload(row) {
      var _this = this
      window.open(_this.buildFileUrl(row, false), '_blank')
    },
    // 附件预览：图片走 ImagePreviewDialog，其余走 FilePreviewDialog
    filePreview(row) {
      var _this = this
      if (!row || !row.AttachmentUrl) {
        _this.$message.warning('该记录未上传附件')
        return
      }
      var name = row.FileName || ''
      if (/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(name)) {
        _this.$refs.imgPreviewDlg.open(row.FileName, row.AttachmentUrl)
      } else {
        _this.$refs.filePreviewDlg.open(row.FileName, row.AttachmentUrl)
      }
    },
    // 父组件在 MemberId 变化时显式调用，必须使用传入的 memberId
    getContractList(memberId) {
      this.currentCustomerId = memberId
      this.queryParam.PageIndex = 1
      this.initialize()
    },
  },
  components: {
    FilePreviewDialog,
    ImagePreviewDialog,
  },
}
</script>

<style></style>
